export enum UserDeviceType {
    MOBILE = 'mobile',
    DESKTOP = 'desktop',
    WEB = 'web',
    EXTERNAL = 'external',
}
